import { render, staticRenderFns } from "./french_resources.vue?vue&type=template&id=a9f828e8&scoped=true"
import script from "./french_resources.vue?vue&type=script&lang=js"
export * from "./french_resources.vue?vue&type=script&lang=js"
import style0 from "./french_resources.vue?vue&type=style&index=0&id=a9f828e8&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9f828e8",
  null
  
)

export default component.exports